import { render, staticRenderFns } from "./PDPDealStory.vue?vue&type=template&id=d737cbcc&scoped=true&"
import script from "./PDPDealStory.vue?vue&type=script&lang=js&"
export * from "./PDPDealStory.vue?vue&type=script&lang=js&"
import style0 from "./PDPDealStory.vue?vue&type=style&index=0&id=d737cbcc&prod&lang=css&"
import style1 from "./PDPDealStory.vue?vue&type=style&index=1&id=d737cbcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d737cbcc",
  null
  
)

export default component.exports